/**
 * @generated SignedSource<<d57bb352929b2063f7d47e71805c918d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionListItemUpdatedInfo_taskExecution$data = {
  readonly isCompleted: boolean;
  readonly lastUpdatedByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"SignedActor_actor">;
  } | null;
  readonly updatedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  } | null;
  readonly " $fragmentType": "TaskExecutionListItemUpdatedInfo_taskExecution";
};
export type TaskExecutionListItemUpdatedInfo_taskExecution$key = {
  readonly " $data"?: TaskExecutionListItemUpdatedInfo_taskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionListItemUpdatedInfo_taskExecution">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionListItemUpdatedInfo_taskExecution",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "lastUpdatedByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignedActor_actor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};

(node as any).hash = "ddad0e2e2e66ee3e5026bae670ff1818";

export default node;
